// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"_130f24","titleAndIcon":"_774b94","avatars":"_db57a8","itemContainer":"_553592","icon":"_04ae94","iconCons":"_c45b84","iconPros":"_883ddc","section":"_3973bc"};